import React from 'react'
import ButtonWithLoader from '../../components/ButtonWithLoader'
import InputControl from '../../components/InputControl'
import { Controller, useForm } from 'react-hook-form'
import { components } from 'react-select'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import {
    statemanagement,
    industrymanagement,
    citymanagement
} from '../../Routes/routingConsts'
import { Dropdown, Form, InputGroup, Button } from 'react-bootstrap'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import requestApi from '../../utils/request'
import { useMutation, useQuery } from 'react-query'
import Swal from 'sweetalert2'
import DropDownControlForLocation from '../../components/DropDownControlForLocation'
import { useState } from 'react'
import DropDownForState from '../../components/DropDownForState'
const { Option } = components
const IconOptionForState = (props) => {
    let val = ''
    const { label, stateName } = props.data

    return (
        <Option {...props}>
            <div className="react-select-option">{stateName}</div>
        </Option>
    )
}
const AddNewCity = () => {
    const cityValidationInput = yup.object({
        name: yup.string().required('Please enter city name'),
        country: yup
            .object()
            .nullable(true)
            .test('one-of', 'Please select country', (val) => {
                return (
                    val?.countryName !== '' &&
                    val?.countryId !== '' &&
                    Boolean(val)
                )
            }),
        state: yup
            .object()
            .nullable(true)
            .test('one-of', 'Please select state', (val) => {
                return (
                    val?.stateName !== '' && val?.stateId !== '' && Boolean(val)
                )
            })
    })
    const {
        handleSubmit,
        reset,
        register,
        control,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(cityValidationInput),
        defaultValues: { state: null }
    })
    const navigate = useNavigate()
    const { countryId, stateId, cityId } = useParams()

    // add - edit city ///
    async function addNewState({ country,state, ...payload }) {
        if (cityId) {
            return await requestApi
                .post(
                    `city/add-edit`,
                    { ...payload, cityId,stateId: state?.stateId },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        } else {
            // let countryName = JSON.parse(country) country:country?.countryId country:country?.countryId,
            return await requestApi
                .post(
                    `city/add-edit`,
                    { ...payload,stateId: state?.stateId },
                    { headers: true }
                )
                .then((res) => {
                    return res.data
                })
        }
    }

    const mutation = useMutation(addNewState, {
        onSuccess: (data) => {
            Swal.fire({
                position: 'center',
                icon: 'success',
                title: '',
                text: data?.meta?.message
            }).then(() => {
                navigate(citymanagement)
            })
        },
        onError: (error) => {
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: '',
                text: error?.message
            })
        }
    })
    // End add-edit state////

    // view-state on id //
    async function viewStateOnId(cityId) {
        return await requestApi
            .post(`/city/view`, { cityId: cityId }, { headers: true })
            .then((res) => {
                return res.data
            })
    }
    const { data, isLoading } = useQuery({
        queryKey: ['view-city'],
        queryFn: () => viewStateOnId(cityId),
        enabled: !!cityId,
        onSuccess: (data) => {
            reset({
                country:{
                    countryName:data?.data[0]?.countryName,
                    countryId:data?.data[0]?.countryId
                },
                state: {
                    stateName: data?.data[0]?.stateName,
                    stateId: data?.data[0]?.stateId
                },
                name: data?.data[0]?.cityName
            })
        }
    })
    // end view state on id //
    const {state:previousState} = useLocation()
    ///// list state Api ////
    async function stateList() {
        return await requestApi.post(
            `state/list`,
            { limit: 5000 },
            { headers: true }
        )
    }
    const { data: stateDataList } = useQuery({
        queryKey: ['state'],
        queryFn: () => stateList('state')
        // enabled: !!userProfile
    })
    /////end state list api ///


    // country list api /////
    async function countryList() {
        return await requestApi.post(
            `country/list`,
            { limit: 550 },
            { headers: true }
        )
    }
    const { data: countryDataList } = useQuery({
        queryKey: ['country'],
        queryFn: () => countryList('country')
        // enabled: !!userProfile
    })

    // end country list api////


    const onSubmit = ({ ...data }) => {
        const payload = {
            ...data
        }
        mutation.mutate(payload)
    }
    return (
        <>
            <div className="sidebar-content">
                <ul className="nav-links">
                    <Link to={citymanagement}>
                        <li>
                            <a href="">City Management</a>
                            <span>&gt;</span>
                        </li>
                    </Link>
                    <li>
                        {cityId ? (
                            <a className="bold">Edit City</a>
                        ) : (
                            <a className="bold">Add City</a>
                        )}
                    </li>
                </ul>

                <Form onSubmit={handleSubmit(onSubmit)}>
                    <div className="whitebox">
                        {cityId ? (
                            <div className="title-text">
                                <h3>Edit City</h3>
                            </div>
                        ) : (
                            <div className="title-text">
                                <h3>Add City</h3>
                            </div>
                        )}

                        <div className="createnew-box">
                            <div className="row">
                            <div className="col-lg-4 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <DropDownControlForLocation
                                            id={true}
                                            name="country"
                                            label="Country Name"
                                            control={control}
                                            options={
                                                countryDataList?.data?.data
                                            }
                                            // className="icontrol"
                                            register={register}
                                            error={errors.country?.message}
                                            // getCountry={(countryId) => {
                                            //     // setCountryId()
                                            //     // setValue('city', JSON.stringify({ _id: '', name: '' }))
                                            // }}
                                        />
                                    </div>
                                </div>


                                <div className="col-lg-4 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <DropDownForState
                                            cmp={IconOptionForState}
                                            id={true}
                                            name="state"
                                            label="State Name"
                                            control={control}
                                            options={stateDataList?.data?.data}
                                            register={register}
                                            error={errors.state?.message}
                                            // getCountry={(countryId) => {
                                            //     // setCountryId()
                                            //     // setValue('city', JSON.stringify({ _id: '', name: '' }))
                                            // }}
                                        />
                                    </div>
                                </div>

                                <div className="col-xl-3 col-lg-6 col-md-6 col-12">
                                    <div className="mb-3 input-wrapper">
                                        <InputControl
                                            label="City Name"
                                            name="name"
                                            // placeholder="City Name"
                                            register={register}
                                            error={errors?.name?.message}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* <div className="whitebox"> */}
                    <div className="jobdes-btn">
                        <ButtonWithLoader
                            isLoading={mutation?.isLoading}
                            cssClass="common-btn comman-auth-btn reset-btn"
                        >
                            {cityId ? (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Edit
                                </button>
                            ) : (
                                <button
                                    type="submit"
                                    className="common-btn create"
                                >
                                    Add
                                </button>
                            )}
                        </ButtonWithLoader>
                        {/* {state ? 
                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={() => {
                                navigate(city)
                            }}
                        >
                            Cancel
                        </button> 
                        :  <button
                        type="button"
                        className="common-btn cancel"
                        onClick={() => {
                            navigate(citymanagement)
                        }}
                    >
                        Cancel
                    </button> } */}

                        <button
                            type="button"
                            className="common-btn cancel"
                            onClick={() => {
                                navigate(citymanagement, {state:previousState })
                            }}
                        >
                            Cancel
                        </button>
                    </div>
                    {/* </div> */}
                </Form>
            </div>
        </>
    )
}

export default AddNewCity
